module.exports = __webpack_public_path__ + "img/offsite2.85673880.png";